export namespace Routes {
  export const home = '/'

  export const projects = '/projects'
  export const about = '/about'
  export const getInTouch = '/contact'
}
